import { createTheme } from "@mui/material/styles";
import { Link } from "react-router-dom";
import { forwardRef } from "react";

let theme = createTheme({
  breakpoints: {
    sm: 600,
    md: 900,
    lg: 1200,
  },

  palette_custom: {
    darkBlueSecondary: "#19232f",
    darkBlue: "#1F2C3C",
    lightBlue: "#657DA2",
    lightGreen: "#90F5CA",
    yellow: "#ffdc4a", //"#F4F928",
    white: "#FFFFFF",
    lightGrey: "#F5F5F5",
    greyBlue: "#F5F7FA",
    sector: "#BDD7FF",
    impact: "#CBFCE4",
    oos: "#FFA4A4",
    grey: "#DDDDDD",
    fund: {
      "Altitude 1": { primary: "#ffdc4a", secondary: "#1F2C3C" },
      "Altitude 2": { primary: "#ffdc4a", secondary: "#1F2C3C" },
      Mission: { primary: "#90F5CA", secondary: "#1F2C3C" },
      Generations: { primary: "#B40031", secondary: "#FFFFFF" },
      Foundation: { primary: "#657DA2", secondary: "#FFFFFF" },
    },
  },
  tag: {
    unscreened: "#FFCFA4",
    outofscope: "#FFA4A4",
    dealflow: "#90F5CA",
    reminder: "#D6D6FF",
    closed: "#D9D9D9",
    sourcing: "#ffdc4a",
  },
  fontSize: {
    lg: "1.2rem",
    md: "1rem",
    sm: "0.8rem",
    xs: "0.6rem",
  },
  fontWeight: {
    100: 100,
    200: 200,
    300: 300,
    400: 400,
    500: 500,
    600: 600,
    700: 700,
  },
  typography: {
    fontSize: 12,
  },
});

theme = createTheme(theme, {
  palette: {
    primary: theme.palette.augmentColor({
      color: { main: "#1F2C3C", light: "#d2d4d8" },
    }),

    secondary: theme.palette.augmentColor({
      color: { main: "#657DA2", extralight: "#dfe4ec" },
    }),

    info: theme.palette.augmentColor({
      color: { main: "#4C961A", light: "#A5E670" },
    }),

    //Colors used in tag
    neutral: theme.palette.augmentColor({ color: { main: "#FFCFA4" } }),
    yellow: theme.palette.augmentColor({ color: { main: "#ffdc4a" } }),
    green: theme.palette.augmentColor({ color: { main: "#90F5CA" } }),
    closed: theme.palette.augmentColor({ color: { main: "#D9D9D9" } }),
    out: theme.palette.augmentColor({ color: { main: "#FFA4A4" } }),
    reminder: theme.palette.augmentColor({ color: { main: "#D6D6FF" } }),
  },
});

const LinkBehaviour = forwardRef(function LinkBehaviour(props, ref) {
  return <Link ref={ref} {...props} />;
});

theme = createTheme(theme, {
  typography: {
    h1: {
      color: theme.palette_custom.darkBlue,
      fontWeight: theme.fontWeight[400],
      fontSize: theme.fontSize.md,
      background: `linear-gradient(
        180deg,
        rgba(255, 255, 255, 0) 50%,
        ${theme.palette.yellow.main} 50%
      )`,
    },
  },
  components: {
    MuiLink: {
      defaultProps: {
        component: Link,
        underline: "hover",
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          variants: [
            {
              props: { ringstyle: "ringapp" },
              style: {
                minHeight: 0,
                padding: "0 2px",
                margin: 2,
                textTransform: "unset",
                border: "1px solid rgb(101, 125, 162)",
                color: theme.palette.primary.main,
                "&.inactive": {
                  color: theme.palette.primary.light,
                },
              },
            },
          ],
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          variants: [
            {
              props: { ringstyle: "ringapp" },
              style: {
                minHeight: 34,
              },
            },
          ],
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        textAlignLeft: {
          "&::before": {
            width: 0,
          },
          "&::after": {
            width: "100%",
          },
          "& .MuiDivider-wrapper": {
            paddingLeft: 0,
          },
        },
      },
    },
    MuiList: {
      variants: [
        {
          props: { variant: "boxed" },
          style: {
            minWidth: "40px",
            "& .MuiListItemButton-root, & .MuiListItem-root": {
              borderColor: theme.palette_custom.lightBlue,
              border: 0.5,
              borderRadius: 1,
              borderStyle: "solid",
              marginBottom: "5px",
            },
          },
        },
      ],
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: theme.palette.primary.main,
        },
      },
      variants: [
        {
          props: { variant: "small" },
          style: {
            minWidth: "40px",
          },
        },
      ],
    },
    MuiListItemAvatar: {
      variants: [
        {
          props: { variant: "small" },
          style: {
            minWidth: "40px",
            "& .MuiAvatar-root": {
              width: 24,
              height: 24,
            },
          },
        },
      ],
    },
    MuiListItemText: {
      styleOverrides: {
        root: {
          maxWidth: "100%",
        },
        primary: {
          textOverflow: "ellipsis",
          overflow: "hidden",
          textWrap: "nowrap",
        },
        secondary: {
          textOverflow: "ellipsis",
          overflow: "hidden",
          textWrap: "nowrap",
        },
      },
    },
    MuiIconButton: {
      defaultProps: {
        color: "primary",
      },
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.grey,
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: 12,
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          "& .MuiDataGrid-cell": {
            padding: "0 8px",
          },
        },
      },
    },
  },
});

export default theme;
